
import { Link } from "react-scroll";

/*--------------------
* Footer Section
----------------------*/
function Footer() {
    return (
        <footer className="footer bg-slate-900 border-t border-white border-opacity-10 py-4">
            <div className="container">
                <div className="grid grid-cols-12">
                    <div className="col-span-12 md:col-span-6 flex pb-3 md:pb-0">
                        <div className="flex justify-center md:justify-start w-full">
                            <Link className="text-white text-opacity-90 hover:text-orange-600 mr-5 text-[16px]" to="#" 
                            onClick={() =>  window.location.assign('https://join.skype.com/invite/qVuOCBhvHN6I')}><i className="fab fa-skype"></i></Link>
                            <Link className="text-white text-opacity-90 hover:text-orange-600 mr-5 text-[16px]" to="#" 
                            onClick={() =>  window.location.assign('https://www.linkedin.com/in/patoliyadikshit')}><i className="fab fa-linkedin-in"></i></Link>
                        </div>
                    </div>
                    <div className="col-span-12 md:col-span-6 text-center md:text-right">
                        <p className="m-0 text-white text-opacity-75">© 2023 copyright all right reserved by patoliya dikshit</p>
                    </div>
                </div>
            </div>
        </footer>
     );
}

export default Footer;